import { Icon } from '@/components/ui/Icon';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { RESOURCES } from '@/data/resources';
import styles from './Resources.module.css';

export interface ResourcesProps {
  readonly titleId: string;
}

export function Resources({ titleId }: ResourcesProps) {
  return (
    <>
      <SectionHeader eyebrow="المصادر" title="مصادر تعليمية موثوقة" titleId={titleId} tight />

      <div className={styles.list}>
        {RESOURCES.map((resource) => (
          <a
            key={resource.url}
            className={styles.row}
            href={resource.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name={resource.icon} size={24} className={styles.icon} />
            <span className={styles.text}>
              <span className={styles.title}>{resource.title}</span>
              <span className={styles.description}>{resource.description}</span>
            </span>
            <span className={styles.cta}>
              زيارة الموقع
              <span className="visually-hidden"> (يفتح في نافذة جديدة)</span>
            </span>
          </a>
        ))}
      </div>
    </>
  );
}
